"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Linkage = void 0;
/**
 * Identifies two or more records (resource instances) that refer to the same real-world \"occurrence\".
 */
var Linkage = /** @class */ (function () {
    function Linkage() {
    }
    return Linkage;
}());
exports.Linkage = Linkage;
